import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

const a: any = [];
export const AbilityContext = createContext(a);
const Can = createContextualCan(AbilityContext.Consumer);
export default Can;
